export const PHONE_COUNTRIES = [
  {
    label: 'Россия (+7)',
    value: 'RU',
    dialCode: '7',
    mask: '+7 (999) 999-99-99',
    placeholder: '+7 (___) ___-__-__',
    digitsCount: 11
  },
  {
    label: 'Беларусь (+375)',
    value: 'BY',
    dialCode: '375',
    mask: '+375 (99) 999-99-99',
    placeholder: '+375 (__) ___-__-__',
    digitsCount: 12
  },
  {
    label: 'Армения (+374)',
    value: 'AM',
    dialCode: '374',
    mask: '+374 (99) 999999',
    placeholder: '+374 (__) ______',
    digitsCount: 11
  },
  {
    label: 'Казахстан (+7)',
    value: 'KZ',
    dialCode: '7',
    mask: '+7 (999) 999-99-99',
    placeholder: '+7 (___) ___-__-__',
    digitsCount: 11
  }
];
